import { render, staticRenderFns } from "./Timbratura.vue?vue&type=template&id=b3cf86b6&scoped=true"
import script from "./Timbratura.vue?vue&type=script&lang=js"
export * from "./Timbratura.vue?vue&type=script&lang=js"
import style0 from "./Timbratura.vue?vue&type=style&index=0&id=b3cf86b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3cf86b6",
  null
  
)

export default component.exports